import React, { useMemo } from "react";
import {
  extractDateFromStr,
  getLatestUpdatedObject,
} from "../../../../Utils/utils";
import { useGetProtectedApiDataQuery } from "../../../../redux/services/apiSlice";
import { useLanguageTranslation } from "../../../../hooks/useLanguageTranslation";

const LastUpdatedOn = () => {
  const { getText } = useLanguageTranslation();
  const { data: getLastUpdatedData = [], isLoading: lastUpdatedIsLoading } =
    useGetProtectedApiDataQuery({ url: "last_update", lang: "" });

  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(
      getLatestUpdatedObject(getLastUpdatedData)?.changed,
    );
  }, [getLastUpdatedData]);

  if (lastUpdatedIsLoading) {
    return (
      <p>
        {getText(
          "Loading last updated date...",
          "अंतिम अपडेट तिथि लोड हो रही है...",
        )}
      </p>
    );
  }

  return (
    <p>
      {getText(
        `Page last updated : ${lastUpdatedOn}`,
        `पृष्ठ अंतिम बार अपडेट किया गया : ${lastUpdatedOn}`,
      )}
    </p>
  );
};

export default LastUpdatedOn;
